
export const AppImages = {
    about: {
        image: '/bgs/about.jpg',
        imagePosition: 'top center',
        slideColor: '#626262',
    },
    contact: {
        image: '/bgs/contact.jpg',
        imagePosition: 'center center',
        slideColor: '#101115',
    },
    work: {
        image: '/bgs/work.jpg',
        imagePosition: 'center center',
        slideColor: '#BF1D20',
    },
    projects: {
        image: '/bgs/projects.jpg',
        imagePosition: 'center center',
        slideColor: '#101115 ',
    },
}

